import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { PageHeader, fmtDate } from "@/components/ui-bits";
import { Field } from "@/pages/Login";
import { Trash2 } from "lucide-react";

export default function AdminAnnouncements() {
  const [rows, setRows] = useState([]);
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");

  const load = async () => { const { data } = await api.get("/admin/announcements"); setRows(data); };
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!title.trim()) return toast.error("Title required");
    try {
      await api.post("/admin/announcements", { title, description: desc });
      toast.success("Published"); setTitle(""); setDesc(""); load();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const del = async (id) => { await api.delete(`/admin/announcements/${id}`); toast.success("Deleted"); load(); };

  return (
    <div>
      <PageHeader title="Announcements" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <div className="glass p-5">
          <h3 className="font-display text-lg font-bold mb-4">New Announcement</h3>
          <div className="space-y-3">
            <Field label="Title" value={title} onChange={setTitle} testid="ann-title" />
            <div>
              <span className="text-xs uppercase tracking-[0.18em] text-[#94A3B8] font-bold">Description</span>
              <textarea value={desc} onChange={(e) => setDesc(e.target.value)} rows={5} data-testid="ann-desc"
                className="mt-2 w-full bg-[#0A132A] border border-white/10 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:border-[#00F0FF]" />
            </div>
            <button onClick={create} data-testid="ann-publish" className="w-full py-3 rounded-lg bg-[#00F0FF] text-[#060B19] font-bold hover:bg-[#00D4E0]">Publish</button>
          </div>
        </div>
        <div className="space-y-3 lg:col-span-2">
          {rows.map((a) => (
            <div key={a.id} className="glass p-4 flex items-start justify-between">
              <div>
                <div className="font-display font-bold">{a.title}</div>
                <div className="text-xs text-[#94A3B8] uppercase tracking-wider mt-1">{fmtDate(a.created_at)}</div>
                <div className="text-sm text-[#94A3B8] mt-2">{a.description}</div>
              </div>
              <button onClick={() => del(a.id)} data-testid={`del-ann-${a.id}`} className="p-2 text-red-300 hover:bg-red-500/15 rounded"><Trash2 size={16} /></button>
            </div>
          ))}
          {rows.length === 0 && <div className="text-[#475569] text-sm py-6 text-center">No announcements yet</div>}
        </div>
      </div>
    </div>
  );
}
